import { Box, Flex, Text } from '@chakra-ui/layout';
import React, { useEffect } from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { Badge, Image, Link, Spinner } from "@chakra-ui/react";
import Video from "../../../images/teacher/video.svg"
import LessonUpload from "../../../images/teacher/lesson upload.svg";
import NoteUpload from "../../../images/teacher/note upload.svg";
import { useSelector } from 'react-redux';
import { useStudentAuthDispatch, StateType } from '../../../store/store';
import { getSubmittedAssignments, getUploadedAssignments } from '../../../action/teacherAction';

export default function TeacherHome() {
  const dispatch = useStudentAuthDispatch();
  const { data, assignments: { assignments }, submittedAssignments } = useSelector((state: StateType) => state.rootReducer.teacherReducer);
  const teacherToken = data.token.includes("Bearer") ? data.token.slice(17, (data.token.length - 2)) : data.token.slice(10, (data.token.length - 2));
  console.log(submittedAssignments)

  useEffect(() => {
    if (data.token !== "") {
      dispatch(getUploadedAssignments(teacherToken))
      dispatch(getSubmittedAssignments(teacherToken))
    }
  }, [teacherToken]);

  let { path, url, params } = useRouteMatch();
  console.log({ params });

  if (data.token === "") {
    return <Flex justifyContent="center" alignItems="center" height="100%" width="100%">
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="blue.500"
        size="xl"
      />
    </Flex>
  }
  return (
    <Flex m={7} flexDirection={"column"}>
      <Flex flexDirection={{ base: "column", lg: "row" }} flex={1} justifyContent={"space-between"}>
        <Link as={NavLink} to={"/tutor/classes"} d={"flex"} alignItems={"center"} borderRadius={"20px"}
          bg={"brand.white"} w={"100%"} mr={{ base: "0", lg: "20px" }} mb={{ base: "15px", lg: "0" }}>
          <Box bgColor={"brand.orange"} borderRadius={"20px"}>
            <Image
              title={"start class"}
              objectFit="cover"
              src={Video}
              alt={"Start class"}
              p={6}
            />
          </Box>
          <Box px={4}>
            <Text fontWeight={"semibold"} textTransform={"capitalize"}>Start a class</Text>
          </Box>
        </Link>
        <Link as={NavLink} to={"/tutor/notes"} d={"flex"} alignItems={"center"} borderRadius={"20px"}
          bg={"brand.white"} w={"100%"} mr={{ base: "0", lg: "20px" }} mb={{ base: "15px", lg: "0" }}>
          <Box bgColor={"brand.orange"} borderRadius={"20px"}>
            <Image
              title={"upload note"}
              objectFit="cover"
              src={NoteUpload}
              alt={"upload note"}
              p={6}
            />
          </Box>
          <Box px={4}>
            <Text fontWeight={"semibold"} textTransform={"capitalize"}>Upload note</Text>
          </Box>
        </Link>
        <Link as={NavLink} to={"/tutor/lessons"} d={"flex"} alignItems={"center"} borderRadius={"20px"}
          bg={"brand.white"} w={"100%"}>
          <Box bgColor={"brand.orange"} borderRadius={"20px"}>
            <Image
              title={"upload lesson"}
              objectFit="cover"
              src={LessonUpload}
              alt={"upload lesson"}
              p={6}
            />
          </Box>
          <Box px={4}>
            <Text fontWeight={"semibold"} textTransform={"capitalize"}>upload lesson</Text>
          </Box>
        </Link>
      </Flex>
      <Flex my={6} p={5} bgColor={"brand.white"} flexDirection={"column"} borderRadius={"20px"}>
        <Text textTransform={"capitalize"} fontWeight={"bold"} fontSize={"2xl"}>assignments</Text>
        {assignments.map((assignment, index) => assignment.assignment_link === "" ? (
          <Text fontWeight={"semibold"} textTransform={"capitalize"}>No Uploaded Assignments</Text>
        ) : (
          <Box key={index} m={3} p={1}>
            <Flex flexDirection={{ base: "column", md: "row" }} justifyContent={"space-between"}
              bgColor={"white"} py={9} px={7} borderRadius={"20px"}>
              <Text textTransform={"capitalize"} fontWeight={"bold"} fontSize={"xl"}>{assignment.course_name}</Text>
              <Badge bgColor={"black"} color={"white"} p={1} borderRadius={"10px"} textAlign={"center"}>
                {submittedAssignments && submittedAssignments.filter((values) => values.assignment_id === assignment.assignment_id).length} submitted
              </Badge>
            </Flex>
          </Box>
        ))}
      </Flex>
    </Flex>
  )
}
